import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ComparisonSection() {
  return <section className="py-24 bg-brown-800 text-white" data-id="element-67">
      <div className="max-w-7xl mx-auto px-4" data-id="element-68">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-69">
          <h2 className="text-4xl md:text-5xl font-serif italic mb-6" data-id="element-70">
            Why Couples Choose Ihsanly
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto bg-cream-100 rounded-3xl overflow-hidden shadow-2xl flex flex-col md:flex-row" data-id="element-71">
          {/* Wedibox Column */}
          <div className="flex-1 p-8 md:p-12 bg-white relative overflow-hidden" data-id="element-72">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-accent-purple to-accent-pink" data-id="element-73" />
            <h3 className="text-2xl font-bold text-brown-900 mb-2" data-id="element-74">Ihsanly</h3>
            <div className="w-12 h-1 bg-accent-pink mb-8 rounded-full" data-id="element-75" />

            <ul className="space-y-6" data-id="element-76">
              {['No equipment to rent or return', "Works from guests' own phones", 'Unlimited voice messages', 'Instant digital access', 'Beautiful, customizable design', 'Starting at $29'].map((item, i) => <li key={i} className="flex items-start space-x-3" data-id="element-77">
                  <div className="mt-1 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center flex-shrink-0" data-id="element-78">
                    <Check className="w-3 h-3 text-green-600" strokeWidth={3} data-id="element-79" />
                  </div>
                  <span className="text-brown-900 font-medium" data-id="element-80">{item}</span>
                </li>)}
            </ul>

            <div className="mt-10 pt-8 border-t border-gray-100" data-id="element-81">
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold mb-1" data-id="element-82">
                Starting at
              </p>
              <p className="text-4xl font-bold text-brown-900" data-id="element-83">$29</p>
            </div>
          </div>

          {/* Traditional Rental Column */}
          <div className="flex-1 p-8 md:p-12 bg-gray-50 border-l border-gray-200" data-id="element-84">
            <h3 className="text-2xl font-bold text-gray-600 mb-2" data-id="element-85">
              Traditional Rental
            </h3>
            <div className="w-12 h-1 bg-gray-300 mb-8 rounded-full" data-id="element-86" />

            <ul className="space-y-6" data-id="element-87">
              {['$400+ rental fee', 'Must pick up and return equipment', 'Limited recording capacity', 'Wait days for audio files', 'Generic, dated look', 'Risk of damage fees'].map((item, i) => <li key={i} className="flex items-start space-x-3 opacity-70" data-id="element-88">
                  <div className="mt-1 w-5 h-5 rounded-full bg-red-100 flex items-center justify-center flex-shrink-0" data-id="element-89">
                    <X className="w-3 h-3 text-red-500" strokeWidth={3} data-id="element-90" />
                  </div>
                  <span className="text-gray-600" data-id="element-91">{item}</span>
                </li>)}
            </ul>

            <div className="mt-10 pt-8 border-t border-gray-200 opacity-70" data-id="element-92">
              <p className="text-sm text-gray-500 uppercase tracking-wider font-bold mb-1" data-id="element-93">
                Typical Cost
              </p>
              <p className="text-4xl font-bold text-gray-600" data-id="element-94">$400+</p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}